var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "slip"
  }, [_c('div', {
    attrs: {
      "id": "printCashMemoData"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables tableExample",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data-pdfmake": "{\"widths\":[150,200,\"*\",\"*\"],\"heights\":15}"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%",
      "border-right": "none"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables tableExample",
    staticStyle: {
      "width": "99.4%",
      "margin-top": "3px",
      "margin-left": "3px",
      "margin-right": "3px"
    },
    attrs: {
      "data-pdfmake": "{\"widths\":[150,200,\"*\",\"*\"],\"heights\":15}"
    }
  }, [_c('tbody', [(_vm.memoData.irn) ? _c('tr', [_c('td', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("IRN Details:")]), _c('br'), _vm._v("\n                    IRN : " + _vm._s(_vm.memoData.irn)), _c('br'), _vm._v("\n                    Ack. No.: " + _vm._s(_vm.memoData.irn && _vm.memoData.irnresponse && _vm.memoData.irnresponse.ackNo ? _vm.memoData.irnresponse.ackNo : "")), _c('br'), _vm._v("\n                    Ack. Date : " + _vm._s(_vm.memoData.irn && _vm.memoData.irnresponse && _vm.memoData.irnresponse.ackNo ? _vm.memoData.irnresponse.ackDate : "")), _c('br')])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Tax Invoice No. : " + _vm._s(_vm.memoData.invoiceid))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Dated: " + _vm._s(_vm.memoData.dated))]), _vm._v(" "), (_vm.memoData.irn) ? _c('td', {
    staticStyle: {
      "padding": "25px 25px 25px 25px"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("IRN QR")]), _vm._v(" "), _c('qr-code', {
    attrs: {
      "size": 350,
      "text": _vm.irnQR
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Busybees Logistics Solutions Pvt.Ltd.")]), _c('br'), _vm._v("\n                Address : " + _vm._s(_vm.memoData.hoaddress)), _c('br'), _vm._v("\n                State Code : " + _vm._s(_vm.memoData.hostatecode)), _c('br'), _vm._v("\n                GST : " + _vm._s(_vm.memoData.hogst) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._m(1), _c('br'), _vm._v("\n                  " + _vm._s(_vm.memoData.consignorname)), _c('br'), _vm._v(_vm._s(_vm.memoData.consignoraddress)), _c('br'), _vm._v("\n                      State :    " + _vm._s(_vm.memoData.consignorstate) + "                  Code :" + _vm._s(_vm.memoData.consginorStateCode)), _c('br'), _vm._v("\n                      GSTIN/UIN:   " + _vm._s(_vm.memoData.consignorgst)), _c('br'), _vm._v("\n                      Place Of Supply:   " + _vm._s(_vm.memoData.consignorstate) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._m(2), _c('br'), _vm._v("\n                  " + _vm._s(_vm.memoData.consigneename)), _c('br'), _vm._v("Address:    " + _vm._s(_vm.memoData.consigneeaddress)), _c('br'), _vm._v("\n                  State Name :    " + _vm._s(_vm.memoData.consigneestate) + "                    Code:   " + _vm._s(_vm.memoData.consgineeStateCode)), _c('br'), _vm._v("\n                  Contact No. :    " + _vm._s(_vm.memoData.consigneecontactno)), _c('br'), _vm._v("GSTIN/UIN:   " + _vm._s(_vm.memoData.consigneegst) + "\n                ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "border-left": "none",
      "border-right": "none",
      "width": "99.4%",
      "margin-top": "3px",
      "margin-left": "3px",
      "margin-right": "3px",
      "margin-bottom": "3px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.awb))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.noofmps))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.invoicevalue))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.origin))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.destination))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.pickupdate))])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "border-left": "none",
      "border-right": "none",
      "width": "99.4%",
      "margin-top": "3px",
      "margin-left": "3px",
      "margin-right": "3px",
      "margin-bottom": "3px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.billweight))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.baserate))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.freight))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.fuelsurcharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.fovcharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.ftccharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.awbcharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.handlingcharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.odacharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.mathadi))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.othercharges))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.memoData.totalamount))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("Amount before Tax")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.memoData.totalamount))]), _vm._v(" "), (_vm.gstflag == true) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("GST @" + _vm._s(_vm.memoData.gstpercent) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.memoData.gst))])]) : _vm._e(), _vm._v(" "), (_vm.cgstflag == true) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("CGST @" + _vm._s(_vm.memoData.cgst) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.memoData.cgstamount))])]) : _vm._e(), _vm._v(" "), (_vm.cgstflag == true) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("SGST @" + _vm._s(_vm.memoData.sgst) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.memoData.sgstamount))])]) : _vm._e(), _vm._v(" "), (_vm.igstflag == true) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("IGST @" + _vm._s(_vm.memoData.igst) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.memoData.igstamount))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("Net Collectable Amount")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.memoData.netamount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "12"
    }
  }, [_c('u', [_vm._v("Total amount (in Words):")]), _vm._v("   " + _vm._s(_vm.memoData.inwords) + " ")])]), _vm._v(" "), _vm._m(5)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('head', [_c('title', [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Consignor Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Consignee Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Waybill No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Invoice Value.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Origin City")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Dest City")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Pickup Date and Time")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Bill Weight")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Base Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Freight")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Fuel Surcharge")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("FOV Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("FTC Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("AWB Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Handling Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("ODA Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Mathadi Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Other Charges")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("Total")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "12"
    }
  }, [_c('br'), _vm._v("FOR BUSYBEES LOGISTICS SOLUTIONS PVT. LTD. "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v("Authorised Signatory ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a189d32","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/FtcRadShipment/FTCMemoDepositSlip/FTCMemoDepositSlip.component.html
// module id = 1359
// module chunks = 3